import { Observable } from 'rxjs';
import { InjectionToken } from '../../injection';
import { InvitationsLinksList } from '../data/invitations-links-list.do';
import { Invite } from '../data/invite.do';
import { RegisterViewModel } from '../data/register-view-model.do';

export interface IInviteService {
  /**
   * Get the registration response for the invitation.
   * @param inviteId The id of the invitation.
   */
  getRegistration(inviteId: string): Observable<RegisterViewModel>;

  /**
   * Send invitations to provided invites.
   * @param organizationId The id of the organization the invitation is sent.
   * @param invites The list of invites.
   */
  createInvites(organizationId: string, invites: Invite[]): Observable<InvitationsLinksList>;

  /**
   * Resend the invitation
   * @param id The id of the invitation.
   */
  resend(id: string): Observable<Object>;
  /**
   * Cancel the invitation
   * @param id The id of the invitation.
   */
  cancel(id: string): Observable<Object>;
}
export const IInviteService = new InjectionToken('IInviteService');
